const EARTH_RADIUS_M = 6371008.8;
const radians = Math.PI / 180;
export function validCoordinates(point) {
  return ['latitude', 'longitude'].every(key => point[key] !== '' && Number.isFinite(Number(point[key]))) && Math.abs(Number(point.latitude)) <= 90 && Math.abs(Number(point.longitude)) <= 180;
}
export function validatePoint(point) {
  const errors = [];
  if (!/^[A-Z]{2}$/.test(point.country_code) || point.country_id !== point.country_code || !point.place_name?.trim() || ['place_name', 'country_name', 'city_name'].some(field => Array.from((point[field] || '').trim()).length > 200)) errors.push('names');
  if (!validCoordinates(point)) errors.push('coordinates');
  if (point.proportion === '' || !Number.isFinite(Number(point.proportion)) || Number(point.proportion) <= 0) errors.push('proportion');
  const inner = Number(point.inner_radius_m), outer = Number(point.outer_radius_m);
  if (point.inner_radius_m === '' || point.outer_radius_m === '' || !Number.isFinite(inner) || !Number.isFinite(outer) || inner < 0 || inner >= outer) errors.push('radius');
  return errors;
}
export function pointPayload(draft) {
  return { ...draft, country_code: draft.country_code.trim().toUpperCase(), country_id: draft.country_code.trim().toUpperCase(), country_name: draft.country_name.trim(), place_name: draft.place_name.trim(), city_name: draft.city_name.trim(), ...Object.fromEntries(['latitude', 'longitude', 'proportion', 'inner_radius_m', 'outer_radius_m'].map(key => [key, Number(draft[key])])) };
}
export function countryProbability(point, points) {
  if (!point.active) return 0;
  const active = points.filter(candidate => candidate.active && candidate.country_code === point.country_code);
  const scale = Math.max(...active.map(candidate => Number(candidate.proportion)), 0);
  return scale > 0 ? (Number(point.proportion) / scale) / active.reduce((sum, candidate) => sum + Number(candidate.proportion) / scale, 0) : 0;
}
export function isLastActive(point, points) {
  return point.active && points.filter(candidate => candidate.active && candidate.country_code === point.country_code).length === 1;
}
function ring(point, radius, segments, reverse = false) {
  const latitude = Number(point.latitude) * radians, longitude = Number(point.longitude) * radians;
  const distance = radius / EARTH_RADIUS_M;
  const coordinates = Array.from({ length: segments }, (_, index) => {
    const bearing = (reverse ? -1 : 1) * 2 * Math.PI * index / segments;
    const targetLat = Math.asin(Math.sin(latitude) * Math.cos(distance) + Math.cos(latitude) * Math.sin(distance) * Math.cos(bearing));
    const targetLon = longitude + Math.atan2(Math.sin(bearing) * Math.sin(distance) * Math.cos(latitude), Math.cos(distance) - Math.sin(latitude) * Math.sin(targetLat));
    return [targetLon / radians, targetLat / radians];
  });
  coordinates.push([...coordinates[0]]);
  return coordinates;
}
export function donutFeature(point, segments = 96) {
  if (!validCoordinates(point) || !Number.isFinite(Number(point.outer_radius_m)) || !(Number(point.outer_radius_m) > 0) || !(Number(point.inner_radius_m) >= 0) || Number(point.inner_radius_m) >= Number(point.outer_radius_m)) return null;
  const coordinates = [ring(point, Number(point.outer_radius_m), segments, true)];
  if (Number(point.inner_radius_m) > 0) coordinates.push(ring(point, Number(point.inner_radius_m), segments));
  return { type: 'Feature', properties: { place_id: point.place_id, active: !!point.active }, geometry: { type: 'Polygon', coordinates } };
}
export function pointBounds(points) {
  const coordinates = points.flatMap(point => donutFeature(point, 32)?.geometry.coordinates[0] || []);
  if (!coordinates.length) return null;
  return [[Math.min(...coordinates.map(p => p[0])), Math.min(...coordinates.map(p => p[1]))], [Math.max(...coordinates.map(p => p[0])), Math.max(...coordinates.map(p => p[1]))]];
}
